module.exports = "<div [@fadeInDown]=\"fadeInDown\" class=\"page_under_construct\">\n  <div class=\"const_icon\">\n      <i class=\"fas fa-cogs\"></i>\n  </div>\n  <h2>Page Under Construction</h2>\n  <p><a routerLink=\"/dashboard\" mat-raised-button color=\"warn\">Back to Dashboard</a></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/page-under-construction/puc.component.html
// module id = ../../../../../src/app/components/page-under-construction/puc.component.html
// module chunks = main